/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useState } from 'react'

import Menu from '../../../../components/Peyks/Menu'

import Switch from "react-switch"

import { useForm } from "react-hook-form"

import { get, put } from '../../../../services/http'
import { notify } from '../../../../components/Toast'

import { ToastContainer } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

import { useParams } from 'react-router'

export default function index() {
  const navigate = useNavigate()
  const { id } = useParams()

  const [name, setName] = useState('')
  const [phonenumber, setPhonenumber] = useState('')
  const [melicode, setMelicode] = useState('')
  const [birthday, setBirthday] = useState('')
  const [education, setEducation] = useState('')
  const [motorCertificate, setMotorCertificate] = useState('')
  const [motorInsurance, setMotorInsurance] = useState('')

  const [clickButton, setClickButton] = useState(false)
  const [peykStatus, setPeykStatus] = useState()

  const [modal, setModal] = useState(false)
  const [cover, setCover] = useState(false)

  const token = localStorage.getItem('token')
  
  document.title = 'ویرایش پیک'

  const { register, handleSubmit, reset } = useForm()

  useEffect(() => {
    get(`/api/admin/peyks/${id}?token=${token}`)
      .then(response => {
        setName(response.data.data.name)
        setPhonenumber(response.data.data.phoneNumber)
        setMelicode(response.data.data.meliCode)
        setBirthday(response.data.data.birthday)
        setEducation(response.data.data.education)
        setMotorCertificate(response.data.data.motorCertificate)
        setMotorInsurance(response.data.data.motorInsurance)
        setPeykStatus(response.data.data.status)

        let defaultValues = {}
        defaultValues.name = response.data.data.name
        defaultValues.phonenumber = response.data.data.phoneNumber
        defaultValues.meliCode = response.data.data.meliCode
        defaultValues.birthday = response.data.data.birthday
        defaultValues.education = response.data.data.education
        defaultValues.motorCertificate = response.data.data.motorCertificate
        defaultValues.motorInsurance = response.data.data.motorInsurance
        reset({ ...defaultValues })
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [id, reset, token])

  const onSubmit = (data, e) => {
    e.preventDefault()
    setClickButton(true)

    put(`/api/admin/peyks/update/${id}?token=${token}`, {
      name: data.name,
      meliCode: data.meliCode,
      phoneNumber: Number(data.phonenumber),
      birthday: data.birthday,
      education: data.education,
      motorCertificate: data.motorCertificate,
      motorInsurance: data.motorInsurance,
    }, {
      'Content-Type': 'application/json'
    }).then(response => {
      console.log(response)
      if (response.data.messageFa === "با موفقیت آپدیت شد") {
        notify('success', 'پیک مورد نظر آپدیت شد')
        setTimeout(() => {
          navigate('/peyk/peyks')
        }, 2000)
      }
    }).catch(error => {
      if (error.response.data.data.code === 11000) {
        notify('error', 'پیک قبلا ثبت نام کرده است')
      } else {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      }
    })
  }

  const categoryHandler = (e) => {
    // setCategorySelect(e.target.value)
    // setCategoryList([])
    // // eslint-disable-next-line array-callback-return
    // categories.map(item => {
    //   if (item.shop[0]._id === e.target.value) {
    //     setCategoryList(oldArray => [...oldArray, item])
    //   }
    // })
  }

  // const deleteHandler = (e) => {
  //   deleteItem(`/api/admin/foods/${id}?token=${token}`)
  //     .then(response => {
  //       setCover(false)
  //       setModal(false)
  //       notify('success', response.data.messageFa)
  //       setTimeout(() => {
  //         navigate('/foods')
  //       }, 2000)
  //     })
  //     .catch(error => {
  //       if (error) {
  //         notify('error', error)
  //       }
  //       notify('error', 'خطا در ارسال اطلاعات')
  //     })
  // }

  const statusHandler = () => {
    let data = { status: true }
    setPeykStatus(!peykStatus)
    if (peykStatus) {
      data = { status: false }
    } else {
      data = { status: true }
    }
    put(`/api/admin/peyks/status/${id}?token=${token}`, data)
      .then(response => {
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/peyk/peyks')
        }, 2000)
      })
      .catch(error => {
        if (error) {
          notify('error', error)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  return (
    <main id='panel'>
      <div className="cover" style={{ display: cover? '': 'none' }}>
      </div>
      <div className='deleteModal' style={{ display: modal? '': 'none' }}>
        <div className="textDeleteModal">
          آیا میخواهید پیک حذف شود؟
        </div>
        <hr />
        <div className="buttons">
          {/* <button onClick={deleteHandler}>حذف شود</button> */}
          <button onClick={e => {
            setCover(false)
            setModal(false)
          }}>انصراف</button>
        </div>
      </div>
      <ToastContainer rtl />
      <Menu page={'peyks'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right' style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
              <div className='text' >
                <div>
                </div>
                <Switch onChange={statusHandler} 
                  checked={peykStatus ? peykStatus : false} 
                  onColor="#86d3ff"
                  onHandleColor="#2693e6"
                  handleDiameter={30}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={20}
                  width={48}
                  className="react-switch"
                  id="material-switch"
                  />
              </div>
              <div>
                {/* <button onClick={e => { 
                  setCover(true)
                  setModal(true) }} style={{ backgroundColor: '#ff6666' }} className='createButton' type='submit'>حذف پیک</button> */}
              </div>
            </div>

            <div className='left'>
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * از طریق سوییچ بالا می توانید نسبت به فعالسازی و غیر فعالسازی پیک اقدام کنید.
            </div>
            <div className='lineTitleFood'>
              <hr />
              اطلاعات پیک
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodName'>نام و نام خانوادگی * :</label>
                <input id='foodName' {...register("name", { required: true, minLength: 3 })} type='text' placeholder='مثلا پیتزا' />
                <small id='foodNameAlert'>نام باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='foodPrice'>کدملی  * :</label>
                <input id='foodPrice' {...register("meliCode", { required: true, minLength: 3 })} className='ltrdirection' type='text' placeholder='25...' />
                <small id='foodPriceAlert'>کدملی باید وارد شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodLevele'>شماره موبایل * :</label>
                <input id='foodLeveleDetails' {...register("phonenumber", { required: true })} className='ltrdirection' type='text' />
                <small id='foodLeveleDetailsAlert'>شماره موبایل باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='foodDiscountPrice'>تاریخ تولد * :</label>
                <input id='foodDiscountPrice' {...register("birthday", { required: true })} className='ltrdirection' type='text' placeholder='24...' />
                <small id='foodDiscountPriceAlert'>تاریخ تولد با تحفیف باید وارد شود</small>
              </div>
            </div>
            <div className="row">
              <div className='column'>
                <label htmlFor='resturantName'>تحصیلات * : </label>
                <select id='resturantName' {...register("education", { 
                  onChange: (e) => {categoryHandler(e)},
                  required: true })}>
                  <option id='none'>انتخاب کنید</option>
                  <option value={'سیکل'}>سیکل</option>
                  <option value={'دیپلم'}>دیپلم</option>
                  <option value={'کاردانی'}>کاردانی</option>
                  <option value={'کارشناسی'}>کارشناسی</option>
                  <option value={'کارشناسی ارشد'}>کارشناسی ارشد</option>
                </select>
                <small id='resturantNameAlert'>رستوران باید انتخاب شود</small>
              </div>
              <div className='column'>
                <label htmlFor='categoryName'>گواهینامه * : </label>
                <select id='categoryName' {...register("motorCertificate", { required: true })}>
                  <option id='none'>انتخاب کنید</option>
                  <option value={"true"}>بله</option>
                  <option value={"false"}>خیر</option>
                </select>
                <small id='categoryNameAlert'>رستوران باید انتخاب شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='categoryName'>بیمه موتور * : </label>
                <select id='categoryName' {...register("motorInsurance", { required: true })}>
                  <option id='none'>انتخاب کنید</option>
                  <option value={"true"}>بله</option>
                  <option value={"false"}>خیر</option>
                </select>
                <small id='categoryNameAlert'>رستوران باید انتخاب شود</small>
              </div>
            </div>
            <button className='createButton' type='submit' style={clickButton ? { backgroundColor: 'gray' } : {}} disabled={clickButton ? true : false}>{clickButton ? 'در حال آپلود ...' : 'آپدیت پیک'}</button>
          </form>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
